import { CircleMarker } from "react-leaflet";
import { BUFFER_PANE, DELETED_DATA_OPACITY_FACTOR } from "../../utilities/constants";
import pointUtilities from "../../utilities/pointUtilities";

export default function DataCpmDot({ point, color, order, children }) {
    const opacity = point.isDeleted ? DELETED_DATA_OPACITY_FACTOR : 1;

    return <CircleMarker
        center={{ lat: point.lat, lng: point.lng }}
        radius={8}
        pane={BUFFER_PANE}
        cpm={pointUtilities.getCpm(point)}
        order={order}
        pathOptions={{ stroke: false, fillColor: color, fillOpacity: opacity }}>
        {children}
    </CircleMarker>
}
